<app-page-meta pageTitle="finzy - Frequently Asked Questions"></app-page-meta>
<app-header *ngIf="finzyDomain"></app-header>
<app-theader *ngIf="otherDomain"></app-theader>
<p class="faq-headertext">Frequently Asked Questions</p>
<div class="row faq-maindiv">

  <ul class="nav nav-pills">
    <li class="active"><a href="#1b" data-toggle="tab">About your Finzy Loan</a>
    </li>
    <li><a href="#2b" data-toggle="tab">About finzy and TripFactory Partnership</a>
    </li>
    <li><a href="#3b" data-toggle="tab">Refunds and Cancellations</a>
  </ul>

  <div class="tab-content clearfix">

    <div class="tab-pane active" id="1b">

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            1.Can I borrow through finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">You can borrow through finzy if you:</p>
        <ul class="font">
          <li>Are an Indian national with identity proof and address proof.</li>
          <li>Are at least 18 years old.</li>
          <li>Have take home salary of more than Rs 25000 or an annual business income of at least 5 lakhs per annum.
          </li>
        </ul>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            2.What is the process for getting a loan through finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">A finzy loan can be acquired in 3 simple steps:</p>
        <ol type=1>
          <li>Submit your loan application on finzy in as little as 5 minutes. You would need your PAN card, proof of
            your residential address, recent photograph and income documents.
          </li>
          <li>Team finzy will analyze your application and give you a loan decision within 1 business day. We will
            indicate to you the loan amount and rate of interest that you would need to pay.
          </li>
          <li>Upon your acceptance of loan terms, your requirement would be listed on finzy. Only approved Investors
            will be able to see your requirement. Typically, your requirement would get funded from Investors in a few
            minutes to a few hours. We will complete the loan document signature process thereon and directly fund your
            bank account.
          </li>
        </ol>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            3.What documents do I give at the time of my registration?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">finzy would need soft copy of following documents for you to assign finzy Rating to
          the loan</p>

        <ul class="font">
          <li>Complete KYC document including your most recent photograph</li>
          <li>Demographic Information</li>
          <li>Bank Account Statement</li>
          <li>Salary Slips</li>
          <li>Income Tax Return or Form 16</li>
        </ul>
        <p class="faq-acc-content">In addition of above, we also take a report on your loan repayment history from
          Equifax Credit Information Services Private Limited, a registered Credit Information Company.</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            4.Can I submit physical copy of these documents?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          finzy strives to reduce the turnaround time in funding your loan requirement. As part of that attempt, we need
          only soft/digital copies of your documents at the time of registration
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            5.What amount can I borrow and at what rate of interest?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          You can borrow loan amounts ranging from &#8377; 50000 to &#8377; 500000. Your credit rating will determine
          the rate of interest you will pay on your finzy loan. The rate of interests at finzy start at 10.99% and go up
          to 27.99% for a 36 month tenure
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            6.What are the tenures available with finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          We offer 36 months as standard tenure, this reduces your monthly EMI and gives you more flexibility with your
          monthly cash-flow. However, if you have applied for a loan through finzy’s partners, you might be eligible to
          get a loan at a non-standard tenure.
          <br/>
          In any case, you have the flexibility to partly or fully prepay without incurring any early
          prepayment penalty. Please note that you can prepay on any day of the month except between 1st and 10th of the
          month.
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            7.What is finzy Rating and how is it calculated?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul class="font">
          <li>finzy uses a scientific approach to analyze repayment capacity of every Borrower.</li>
          <li>Borrowers are rated using our proprietary credit algorithm, this rating is referred to as a finzy
            Rating.
          </li>
          <li>Each rating is linked to a specific rate of interest.</li>

          <li>We study multiple factors of each Borrower across income details, amount of existing commitments and
            leverage, past loan repayment track record and several other related parameters to arrive at a finzy Rating.
          </li>

          <li>The ratings range from A1 to C6, with A1 being most credit worthy and C6 being riskiest credit rating.
          </li>
        </ul>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            8.What are the registration fees at finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          finzy does not charge registration fees. A loan processing fee is charged at the time of disbursal of your
          loan. The fee is a percentage of the amount disbursed and may vary based on your finzy Rating:</p>

        <div class="faqtable">
          <table class="table finzy-datatable table-responsive">
            <thead>
            <tr>
              <th>Category</th>
              <th>Finzy Rating</th>
              <th>% of disbursal amount charged as fee</th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td rowspan=6 class="faqtr">A+</td>
              <td>A+1</td>
              <td>1.00%</td>
            </tr>
            <tr>
              <td>A+2</td>
              <td>1.00%</td>
            </tr>
            <tr>
              <td>A+3</td>
              <td>1.00%</td>
            </tr>
            <tr>
              <td rowspan=6 class="faqtr">A</td>
              <td>A1</td>
              <td>1.00%</td>
            </tr>

            <tr>
              <td>A2</td>
              <td>1.00%</td>
            </tr>

            <tr>
              <td>A3</td>
              <td>1.50%</td>
            </tr>

            <tr>
              <td>A4</td>
              <td>1.50%</td>
            </tr>

            <tr>
              <td>A5</td>
              <td>2.00%</td>
            </tr>

            <tr>
              <td>A6</td>
              <td>2.00%</td>
            </tr>

            <tr>
              <td rowspan=6 class="faqtr">B</td>
              <td>B1</td>
              <td>3.00%</td>
            </tr>


            <tr>
              <td>B2</td>
              <td>3.00%</td>
            </tr>

            <tr>
              <td>B3</td>
              <td>3.00%</td>
            </tr>

            <tr>
              <td>B4</td>
              <td>4.00%</td>
            </tr>

            <tr>
              <td>B5</td>
              <td>4.00%</td>
            </tr>

            <tr>
              <td>B6</td>
              <td>4.00%</td>
            </tr>

            <tr>
              <td rowspan=6 class="faqtr">C</td>
              <td>C1</td>
              <td>4.50%</td>
            </tr>

            <tr>
              <td>C2</td>
              <td>4.50%</td>
            </tr>

            <tr>
              <td>C3</td>
              <td>4.50%</td>
            </tr>

            <tr>
              <td>C4</td>
              <td>5.00%</td>
            </tr>

            <tr>
              <td>C5</td>
              <td>5.00%</td>
            </tr>

            <tr>
              <td>C6</td>
              <td>5.00%</td>
            </tr>

            </tbody>
          </table>
          <p class="tablefooter">Note: GST of 18% on the processing fee will be additionally levied.</p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            9. What is the Credit Assessment Process at finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          The Objective of the credit assessment process is to assess borrowers on a wide range of parameters using our
          proprietary and scientific Finzy Credit Algorithm to ensure Right Borrowers are verified and loans are
          sanctioned.
        </p>
        <p class="step-header faq-acc-content">Basic Qualifying Criteria</p>
        <ul class="left-spaced">
          <li>Applicant should 18 years of age or above</li>
          <li>Should be an Indian National with valid address and ID proof</li>
          <li>Should have a steady Income (Rs.25000 or more in case Salaried or an annual business income of at least 3
            lakhs in case Self-Employed)
          </li>
        </ul>

        <p class="step-header faq-acc-content">Step 1: KYC Re-validation</p>
        <p class="faq-acc-content">At this stage the documents which has cleared the KYC stage and moved for Preliminary
          Credit Decision stage are re-validated.</p>

        <p class="step-header faq-acc-content">Step 2: Detailed Credit Decision Stage</p>
        <p class="faq-acc-content">This stage involves a detailed analysis on the below parameters</p>
        <ul class="left-spaced">
          <li>Demographic Information</li>
          <li>Income and Employment Details</li>
          <li>Savings and Investment Patterns</li>
          <li>Analysis of committed and Voluntary Expenses</li>
          <li>Leverage Ratios</li>
          <li>Past repayment track record</li>
          <li>Analysis of utilisation of credit lines</li>
          <li>Social Media Activity</li>
          <li>Field verification and Database checks</li>
        </ul>
        <p class="faq-acc-content">Basis the above analysis the final rating is populated by the proprietary finzy
          credit algorithm which decides the loan amount and rate of interest.</p>

        <p class="step-header faq-acc-content">Step 3: Customer Communication and Sanction</p>
        <p class="faq-acc-content">Customers are out-called and communicated on the Loan offer followed by a Sanction
          letter to the registered Email ID which has complete information on the Loan amount, Approximate monthly EMI,
          processing fees and GST charges. The loan gets listed on the platform once the same is accepted.</p>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            10.Is my identity revealed upon listing?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          Your identity or your photograph is not revealed to investors at the listing stage.
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            11.Who is funding my loan?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">Your loan requirement is funded only by registered Investors. Minimum 5 (five)
          investors would be investing in your requirement. finzy takes care of all the documentation, collection and
          co-ordination activities. For you, finzy remains the point of contact for any requirement with respect to your
          loan.</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            12.How is Interest Calculated?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          Interest calculations are on reducing balance basis. Interest is applicable only on the outstanding amount.
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            13.How is EMI collected?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          Every month an EMI amount would be debited from your account electronically. You just need to ensure that
          adequate funds are maintained in your bank account.
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            14.Can I make a prepayment or pre-closure?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">Yes, you can repay your loan early without incurring any early repayment penalty. You
          can either
          choose to foreclose the loan by repaying the entire outstanding amount or reduce the EMI by prepaying a part
          of the
          outstanding amount. In order to prepay your loan, please write an email to
          <a target="_blank" href="mailto:support@finzy.com">support@finzy.com</a>.
          Please note that you can prepay on any day of the month except between 1st and 10th of the month.
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            15.What happens if I miss a payment?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">Any delay or default of EMI would impact your capacity to borrow in future.</p>
        <p class="faq-acc-content">We would levy penal interest rate and delayed payment charges as follows:</p>
        <p class="faq-acc-content">Finzy fee component (variable that keeps changing every 30 days) + Penal fee
          component (Variable that changes based on the outstanding principal amount and the number of days of
          delay)</p>

        <div class="faqtable">
          <table class="table finzy-datatable table-responsive">
            <thead>
            <tr>
              <th>Principal Outstanding</th>
              <th>Penalty</th>
              <th class="text-center">Finzy Fees</th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td>1 - 50000</td>
              <td>&#8377; 15 per day of delay</td>
              <td rowspan="6" class="center-in-column">
                6 to 30 days: &#8377; 500<br>31 to 60 days: &#8377; 1000<br>
                61 to 90 days: &#8377; 1500<br>91 days and beyond: &#8377; 2000<br>
              </td>
            </tr>

            <tr>
              <td>50,001 - 1,50,000</td>
              <td>&#8377; 30 per day of delay</td>
            </tr>

            <tr>
              <td>1,50,001 - 2,50,000</td>
              <td>&#8377; 60 per day of delay</td>
            </tr>

            <tr>
              <td>2,50,001 - 3,50,000</td>
              <td>&#8377; 90 per day of delay</td>
            </tr>

            <tr>
              <td>3,50,001 - 4,50,000</td>
              <td>&#8377; 120 per day of delay</td>
            </tr>

            <tr>
              <td>4,50,001 - 5,00,000</td>
              <td>&#8377; 150 per day of delay</td>
            </tr>

            </tbody>
          </table>
        </div>
        <p class="faq-acc-content">
          For example, a person with a loan amount of &#8377; 2,00,000 whose EMI is overdue by 40 days will have to pay
          a finzy fee of &#8377; 1000 and a penal fee of &#8377; 2400 (60*40) along with his regular EMI.
        </p>
        <p class="faq-acc-content">
          We have tie ups with bank recognized collection agencies across the country, in case of continued default,
          these agencies would approach you for collecting the outstanding principal, interest and penal charges. You
          may also have to face the consequences of legal proceedings and your details might be reported to credit
          information companies and various defaulter databases.
        </p>

      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            16.What documents would need my signature before disbursal of loan?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">Our representative will collect following documents before disbursement of loan:</p>
        <ul class="font">
          <li>Loan Agreement</li>
          <li>3 (Three) post dated cheques (PDCs)</li>
          <li>Demand Promissory Note</li>
          <li>National Automated Clearing House (NACH) registration mandate</li>
          <li>Borrower Declaration form (This document gives your consent for us to transfer the loan amount into
            TripFactory's bank account)
          </li>
        </ul>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            17.Why do I need give post dated cheques to finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          Post dated cheques are used in the event your electronic EMI mandate is not setup properly or we need to
          recover loan amounts which have been outstanding and overdue. These cheques are in name of Bridge Fintech
          Solutions Private Limited, parent company of finzy. Do not worry, we at finzy ensure that your cheques are not
          misused in any way.
        </p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            18.Are the loans secured?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">finzy offers collateral free loans. In the event of continued default, documents
          collected above serve as security to initiate criminal proceedings under Indian legal system.</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            19.Why has my Loan Application been rejected?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">finzy reserves the right to decline a loan application in case of insufficient credit
          worthiness. As per our credit verification process, incomplete documentation in accordance with finzy policy,
          unsuccessful document verification, submission of incorrect information deliberately to cheat the finzy
          systems and processes, are reasons to decline loan applications.</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            20.Can a borrower be an investor as well?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">Yes. If you have registered as a borrower on finzy, then you can also register as an
          investor, irrespective of what stage your loan application is in. However, you will not be allowed to invest
          in your own loan.</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            21.How is Bridge Fintech Solutions Private Limited connected with finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">The domain name www.finzy.com and brand name finzy, is owned and operated by Bridge
          Fintech Solutions Private Limited, a private limited company incorporated under the Companies Act, 2013 with
          its registered office at, L&T Crescent Bay, T-5, 2002, Jerbai Wadi Road, Parel, Mumbai 400 012, Maharashtra,
          India.
        </p>
      </mat-expansion-panel>


    </div>


    <div class="tab-pane" id="2b">

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            1.What is the relation between TripFactory and finzy?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">finzy acts as a finance partner for TripFactory. Apart from this, finzy and
          TripFactory operate independently and are independent companies. finzy offers personal loans for other
          purposes as well and TripFactory offers payment options other than finzy.</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            2.Do I have to pay any loan processing fees to finzy or TripFactory?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">finzy charges a loan processing fee as explained in Question 8 in 'About your Finzy
          Loan' section. TripFactory does not charge any additional loan processing fees</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            3.Who will I pay my EMIs to?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">You will be paying your EMIs to finzy. The amount will be collected automatically
          from your bank account as mentioned in response to question 12 in 'About your Finzy Loan' section.</p>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            4.Will finzy transfer my complete sanctioned loan amount to TripFactory's bank account?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">The final amount transfered to TripFactory's bank account to finance your holiday
          will be the loan amount post deduction of the processing fee charged by finzy and the applicable GST for the
          same.</p>
        <p class="faq-acc-content">(Details of the processing fee + GST are explained in response to Questions 8 and 22.
          )</p>

        <p class="faq-acc-content">For example:</p>
        <p class="faq-acc-content">If the Sanctioned Loan Amount was &#8377; 100,000 at an interest rate of 10.99% and
          the applicable finzy processing charge was 1%, then the final amount transfered to TripFactory's bank account
          will be as follows:</p>
        <p class="text-center">&#8377; 100,000(loan amt) - &#8377; 1,000(processing fee)- &#8377; 180 (18% GST on
          processing fee) =
          &#8377; 98,820</p>
        <p class="faq-acc-content">You will have to pay the remaining amount (i.e. processing fee+GST ) directly to
          TripFactory.</p>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            5.Do I have to pay any loan processing fees to finzy or TripFactory?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          finzy charges a loan processing fee as explained in response to Question 8 in 'About your Finzy Loan' section.
          TripFactory does not charge
          any additional loan processing fees
        </p>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            6.If finzy rejects my loan, will I still be able to travel with TripFactory?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          If finzy rejects your loan request, you can still travel with TripFactory. However you will have to complete
          the trip payment by an alternate mode of payment.
        </p>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            7.If I wish to decline the finzy loan offer, will I still be able to travel with TripFactory?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">
          If you choose to decline the finzy loan offer, you can still travel with TripFactory. However you will have to
          complete the trip payment by an alternate mode of payment.
        </p>
      </mat-expansion-panel>
    </div>

    <div class="tab-pane" id="3b">

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            1.What if there is a change in the cost of the holiday package?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">A loan is sanctioned only after a discussion with the tripfactory expert and you.
          Hence, once the loan offer is made, there cannot be a change in the loan amount. The loan will be fulfilled
          and disbursed based on this amount.</p>
        <p class="faq-acc-content">Here is how changes to holiday packages will be handled in various scenarios</p>
        <p class="faq-acc-content">Scenario 1: Loan Disbursed to TripFactory's account, but there is an increase in cost
          of the holiday package
          In case of an increase in the cost of the holiday package, you will have to directly pay the differential
          amount to TripFactory and your finzy Loan amount will remain unchanged. You will be required to continue
          paying EMIs to finzy for your loan amount.</p>
        <p class="faq-acc-content">Scenario 2: Loan Disbursed to TripFactory's account, but there is a reduction in cost
          of the holiday package
          In this case, TripFactory will return the differential amount back to finzy and it will be considered as part
          prepayment of your loan. You will not be charged any prepayment charges from finzy.</p>
        <p class="faq-acc-content">Please note that the prepayment will be considered as on the date on which finzy
          receives the refund amount from TripFactory. Interest for the entire loan will be effective until we receive
          this amount. Once we process the pre-payment, you will have to continue paying EMIs only for the remaining
          loan amount.</p>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            2.What if I cancel my travel after the loan is disbursed?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-acc-content">TripFactory cancellation charges are based on many factors. TripFactory will return
          the loan amount to finzy after deducting the cancellation charges. This will be counted as a part repayment of
          your loan. You will be required to continue paying EMIs to finzy on the remaining portion of your loan.</p>
        <p class="faq-acc-content">However until finzy receives the refund amount from TripFactory, you will have to
          continue paying EMIs on the entire loan amount.</p>
      </mat-expansion-panel>
    </div>
  </div>
</div>

<app-footer *ngIf="finzyDomain"></app-footer>
<app-tfooter *ngIf="otherDomain"></app-tfooter>
